export default __webpack_public_path__ + "static/media/ift.5f0a7234.ico";